interface Mapping {
  [index: string]: string;
}
export const thema: Mapping = {
  '1A': 'Monde',
  '1D': 'Europe',
  '1F': 'Asie',
  '1H': 'Afrique',
  '1K': 'Les Amériques',
  '1M': 'Australasie, Océanie et autres parties du monde',
  '1Q': 'Autres zones géographiques, océans et mers',
  '1Z': 'Espace, planètes et lieux extraterrestres',
  '2A': 'Langues indo-européennes',
  '2B': 'Langues indo-aryennes, indo-européennes et dravidiennes',
  '2C': 'Langues afro-asiatiques',
  '2F': 'Langues ouralo-altaïques et hyperboréennes',
  '2G': "Langues de l'Asie de l'Est et du Sud-Est",
  '2H': 'Langues africaines',
  '2J': "Langues autochtones de l'Amérique",
  '2P': 'Langues océaniennes et austronésiennes',
  '2Z': 'Autres langues',
  '3B': 'Préhistoire',
  '3C': 'Période av. J.-C., protohistoire',
  '3K': "De l'ère chrétienne à environ 1500",
  '3M': 'De 1500 à nos jours',
  '4C': "Tous niveaux d'enseignement",
  '4G': 'Programmes scolaires et examens internationaux',
  '4L': "Cours et examens d'apprentissage des langues",
  '4T': 'Pour des objectifs éducatifs particuliers',
  '4Z': "Programmes d'enseignement nationaux particuliers",
  '5A': "Âge / niveau d'intérêt",
  '5H': 'Vacances, événements et saisons',
  '5J': 'Destiné à des groupes particuliers',
  '5P': 'Relatif à des groupes et cultures particuliers',
  '5X': 'Contenant un contenu explicite',
  '6A': 'Styles (A dans la version anglaise)',
  '6B': 'Styles (B dans la version anglaise)',
  '6C': 'Styles (C dans la version anglaise)',
  '6D': 'Styles (D dans la version anglaise)',
  '6E': 'Styles (E dans la version anglaise)',
  '6F': 'Styles (F dans la version anglaise)',
  '6G': 'Styles (G dans la version anglaise)',
  '6H': 'Styles (H dans la version anglaise)',
  '6J': 'Styles (IJ dans la version anglaise)',
  '6K': 'Styles (K dans la version anglaise)',
  '6L': 'Styles (L dans la version anglaise)',
  '6M': 'Styles (M dans la version anglaise)',
  '6N': 'Styles (NO dans la version anglaise)',
  '6P': 'Styles (P dans la version anglaise)',
  '6Q': 'Styles (Q dans la version anglaise)',
  '6R': 'Styles (R dans la version anglaise)',
  '6S': 'Styles (S dans la version anglaise)',
  '6T': 'Styles (T dans la version anglaise)',
  '6U': 'Styles (U dans la version anglaise)',
  '6V': 'Styles (V dans la version anglaise)',
  '6W': 'Styles (W dans la version anglaise)',
  '6X': 'Styles (XYZ dans la version anglaise)',
  AB: 'Arts: généralités',
  AF: "Beaux-arts: formes d'art",
  AG: 'Beaux-arts: techniques et sujets',
  AJ: 'Photographie et photographies',
  AK: 'Art industriel / commercial et design',
  AM: 'Architecture',
  AT: 'Arts du spectacle',
  AV: 'Musique',
  CB: 'Langage: références et généralités',
  CF: 'Linguistique',
  CJ: 'Apprentissage et enseignement des langues',
  DB: 'Textes anciens, classiques et médiévaux',
  DC: 'Poésie',
  DD: 'Théâtre',
  DN: 'Biographie et littérature hors fiction',
  DS: 'Littérature: histoire et critique',
  FB: 'Fiction: générale et littéraire',
  FC: 'Biographie romancée',
  FD: 'Roman spéculatif',
  FF: 'Roman policier',
  FG: 'Roman sportif',
  FH: 'Thriller / suspense',
  FJ: "Roman d'aventures",
  FK: "Roman d'épouvante et de surnaturel",
  FL: 'Science-fiction',
  FM: 'Fantasy',
  FN: 'Mythe et légende romancés',
  FP: 'Roman érotique',
  FQ: 'Roman abordant un mode de vie',
  FR: 'Roman sentimental',
  FS: 'Roman abordant la vie familiale',
  FT: 'Sagas familiales',
  FU: 'Roman humoristique',
  FV: 'Roman historique',
  FW: 'Roman religieux et spirituel',
  FX: 'Roman: thèmes narratifs',
  FY: 'Fiction: particularités',
  FZ: 'Guides de fiction',
  GB: 'Encyclopédies et travaux de référence',
  GL: "Bibliothéconomie et sciences de l'information / muséologie",
  GP: 'Information et traitement de données: généralités',
  GT: 'Études interdisciplinaires',
  JB: 'Société et culture: généralités',
  JH: 'Sociologie et anthropologie',
  JK: 'Services sociaux et assistance sociale, criminologie',
  JM: 'Psychologie',
  JN: 'Éducation',
  JP: 'Politique et gouvernement',
  JW: 'Conflit et défense',
  KC: 'Économie',
  KF: 'Finance et comptabilité',
  KJ: 'Affaires et gestion',
  KN: 'Industrie et études industrielles',
  LA: 'Jurisprudence et questions générales',
  LB: 'Droit international',
  LN: 'Droit des juridictions spécialisées et domaines particuliers du droit',
  LW: 'Charia (loi islamique)',
  LX: "Droit: guides d'étude et de révision",
  MB: 'Médecine: généralités',
  MF: 'Médecine préclinique: sciences de base',
  MJ: 'Médecine clinique et interne',
  MK: 'Spécialités médicales, branches de la médecine',
  MN: 'Chirurgie',
  MQ: 'Soins infirmiers et services auxiliaires',
  MR: 'Études médicales, guides de révision et matériel de référence',
  MX: 'Médecine non conventionnelle',
  MZ: 'Médecine vétérinaire',
  NH: 'Histoire',
  NK: 'Archéologie',
  PB: 'Mathématiques',
  PD: 'Sciences: généralités',
  PG: 'Astronomie, espace et temps',
  PH: 'Physique',
  PN: 'Chimie',
  PS: 'Biologie, sciences de la vie',
  QD: 'Philosophie',
  QR: 'Religion et croyances',
  RB: 'Sciences de la Terre',
  RG: 'Géographie',
  RN: 'Environnement',
  RP: 'Aménagement du territoire',
  SC: 'Sport: généralités',
  SF: 'Sports / jeux de ballon',
  SH: 'Athlétisme, gymnastique et sports liés',
  SK: 'Sports équestres et avec des animaux',
  SM: 'Sports pratiqués avec un véhicule',
  SP: 'Sports nautiques',
  SR: 'Sports de combat et de défense',
  ST: "Sports d'hiver",
  SV: 'Activités de plein air: pêche, chasse, tir',
  SX: 'Autres sports et compétitions',
  SZ: 'Activités de plein air',
  TB: 'Technologie: généralités',
  TC: 'Génie biochimique',
  TD: 'Chimie industrielle et technologies industrielles',
  TG: 'Génie mécanique et matériels',
  TH: 'Génie industriel',
  TJ: 'Ingénierie électronique et technologie des communications',
  TN: 'Génie civil, expertise et construction',
  TQ:
    "Science de l'environnement / science environnementale, ingénierie et technologie",
  TR: "Technologie des transports et secteurs d'activité",
  TT: 'Autres technologies et sciences appliquées',
  TV: 'Agriculture et élevage',
  UB: "Technologies de l'information: questions générales",
  UD: 'Le numérique dans la vie quotidienne',
  UF: 'Applications métiers',
  UG: 'Applications graphiques et applications médias numériques',
  UK: 'Matériel informatique',
  UL: "Systèmes d'exploitation",
  UM: 'Programmation informatique / génie logiciel',
  UN: 'Bases de données',
  UQ: 'Certification informatique',
  UR: 'Sécurité informatique',
  UT: 'Gestion de réseaux informatiques et des communications',
  UX: 'Informatique appliquée',
  UY: 'Informatique',
  VF: 'Famille et santé',
  VS: 'Auto-assistance et développement personnel',
  VX: '« Mind, body, spirit »',
  WB: 'Cuisine, alimentation et boisson, etc.',
  WC: 'Antiquités et objets de collection',
  WD: 'Passe-temps, questionnaires et jeux',
  WF: 'Artisanats, arts décoratifs et travaux manuels',
  WG: 'Transports: généralités',
  WH: 'Humour',
  WJ: "Guides de style de vie et d'apparence personnelle",
  WK: 'Entretien de la maison',
  WM: 'Jardinage',
  WN: 'Nature et monde naturel: généralités',
  WQ: 'Histoire locale / régionale, familiale, nostalgie',
  WT: 'Voyage et vacances',
  WZ: 'Éléments divers',
  XA: 'Romans graphiques, livres de bande dessinée: typologie',
  XQ: 'Romans graphiques, livres de bande dessinée: genres',
  XR: 'Romans graphiques, livres de bande dessinée: guides et critiques',
  XY: 'Comic strip',
  YB: "Livres, albums et livres d'activités pour les tout-petits",
  YD: 'Jeunesse: poésie, anthologies, albums',
  YF: 'Fiction jeunesse et histoires vraies',
  YN: 'Documentaires jeunesse: généralités',
  YP: 'Matériel didactique',
  YR: 'Jeunesse: ouvrages de référence',
  YX: 'Jeunesse: questions personnelles et de société',
  YZ: 'Jeunesse: papeterie et objets divers',
};
